import React, { useContext, useEffect } from 'react';
import { Loader } from '@mummssoftware/common-ui';
import { VitalsContext } from '../../containers/VitalsContext/VitalsContextProvider';
import { SET_MEASURE_FIELDS } from '../../containers/VitalsContext/constants';
import { VitalsSelect } from './VitalsSelect';
import {
  patientRefused,
  notTaken,
  tableHeight,
} from '../../containers/MeasuresContext/utils/constants';
import { MeasuresContext } from '../../containers/MeasuresContext/MeasuresContextProvider';

type measuresType = mumms.measureType;

type VitalsFormProps = {
  measuresTypes: measuresType[];
  measuresNames: string[];
  chartHeight: number;
};

export const VitalsForm = React.memo(
  ({ measuresTypes, measuresNames, chartHeight }: VitalsFormProps) => {
    const vitalsContext = useContext(VitalsContext);
    const { isLoading } = useContext(VitalsContext);

    const { tableSelected } = useContext(MeasuresContext);

    const measureFields = (() => {
      const allMeasures: any = {};
      measuresTypes &&
        measuresTypes.forEach((measure: measuresType) => {
          const { id, shortname, readonly } = measure;
          const options =
            measure.iscontrolledlist === 'true'
              ? JSON.parse(measure.values)
              : [];
          const units =
            measure.units &&
            JSON.parse(measure.units)
              .filter((m: any) => m.unitshortname !== patientRefused)
              .filter((m: any) => m.unitshortname !== notTaken);

          allMeasures[shortname] = {};
          /* The unique value name */
          allMeasures[shortname].id = id;
          /* The label text for the value */
          allMeasures[shortname].label = shortname;
          /* The unique value name */
          allMeasures[shortname].name = shortname;
          allMeasures[shortname].readonly = readonly;
          /* The drop down items for the value */
          allMeasures[shortname].options = options;
          allMeasures[shortname].units = units;
        });
      return allMeasures;
    })();

    useEffect(() => {
      if (measureFields) {
        vitalsContext.dispatch({
          type: SET_MEASURE_FIELDS,
          payload: measureFields,
        });
      }
    }, []);

    return measureFields ? (
      <>
        {isLoading ? <Loader /> : null}
        <div id="scores-form-vitals">
          <div className="measures-vitals-form-container">
            <React.Fragment>
              {measureFields &&
                measuresNames &&
                measuresNames?.map((measure) => (
                  <VitalsSelect
                    {...measureFields[measure]}
                    key={measure}
                    chartHeight={
                      measure === tableSelected
                        ? chartHeight + tableHeight
                        : chartHeight
                    }
                    measuresNames={measuresNames}
                  />
                ))}
            </React.Fragment>
          </div>
        </div>
      </>
    ) : (
      <></>
    );
  },
);
